import { useAppMutation } from "../../../http/useAppMutation.ts";
import { useBoardUuid } from "./useBoardUuid.ts";

export const useAddAssetsToTag = ({ assetUuids }: { assetUuids: string[] }) => {
  const boardUuid = useBoardUuid();

  const addAssetsToTagMutation = useAppMutation({
    path: "asset-tags/add-assets",
    invalidate: [
      ...assetUuids.map((uuid) => `assets/${uuid}`),
      `boards/${boardUuid}/assets`,
    ],
  }).mutation;

  return {
    mutate: (tagUuid: string | undefined) => {
      addAssetsToTagMutation.mutate({
        asset_uuids: assetUuids,
        tag_uuid: tagUuid,
      });
    },
    isLoading: addAssetsToTagMutation.isLoading,
  };
};
